module.exports = __webpack_public_path__ + "static/media/climased-interreg-nwe-co-funded-by-the-eu.ceec4d28.png";